import React, { useEffect, useState } from "react";
import Graph from "./Graph.tsx";
import ReusableTable from "../../components/common/Table.tsx";
import { useLocation } from "react-router-dom";
import { MRT_PaginationState } from "material-react-table";
import BreadCrumb from "./BreadCrumb.tsx";
import { GetBatchPredictionResult } from "../../modules/predictorModule.ts";
import {toast, ToastContainer} from 'react-toastify';
interface ForecastItem {
  date: string;
  value: number;
  confidence: number;
}

interface TableGraphProps {
  data: {
    forecast: ForecastItem[];
  };
}

const TableGraph = () => {
  const location = useLocation();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  //const toast = useToast();
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (location?.state?.prediction_id) {
          try {
            const predictionResp = await GetBatchPredictionResult(
              location.state.prediction_id
            );
            setData(predictionResp?.prediction_output)
          } catch (error) {
            const errorMessage =
              error?.response?.data?.detail ||
              "Failed to view batch prediction result";
            toast.error(errorMessage);
          }
        } else {
          setData(location.state.data)
        }

      } catch (error) {
        console.error("Error fetching columns:", error);
        toast.error("Failed to load form data");
      }
    };

    fetchData();
  }, []);

  const columns = [
    { accessorKey: "date", header: "Date" },
    { accessorKey: "value", header: "Forecast Value" },
    { accessorKey: "confidence", header: "Confidence (%)", Cell: ({ cell }) => cell.getValue() ?? "-" },
  ];

  return (
    <>
      <BreadCrumb moduleName={"Training"} pageName={"Forecast Result"} viewName={location?.state?.predictor_name} />
      <ToastContainer position="top-center" />
      <div className="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-lg-center gap-2 mb-1 mt-0">
        <div className="d-flex flex-row gap-2">
          <h5 className="rv-page-title p-2">Form Based Forecast</h5>
        </div>
      </div>

      <Graph data={data?.forecast} />
      <div className="container-fluid px-0 mt-4">
        <div className="disable-margin-card table-responsive table-customer border table-border w-100">
          {data?.forecast && <ReusableTable columns={columns} data={data?.forecast} pagination={pagination} onPaginationChange={setPagination} />}
        </div>
      </div>
    </>
  );
};

export default TableGraph;
